import { render } from "./ToastUpdateButton.vue?vue&type=template&id=0f9aa528&scoped=true"
const script = {}

import "./ToastUpdateButton.vue?vue&type=style&index=0&id=0f9aa528&scoped=true&lang=css"

import exportComponent from "/builds/sites/smolke/app-kwispelcoach-com/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f9aa528"]])

export default __exports__